import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getMyDayTimetable(payload) {
  return { type: actionTypes.GET_MYDAY_TIMETABLE, payload };
}
export function getMyDayTimetableSuccess(payload) {
  const byId = keyBy(payload, (timetable) => timetable.mydaytimetablesUid);
  return { type: actionTypes.GET_MYDAY_TIMETABLE_SUCCESS, payload};
}
